import { Caption as e, Small as t, Title as n } from "../../Typography/Typography.mjs";
import { HeaderLeft as r, HeaderRight as i, HeaderText as a, IconBackdrop as o, StyledBody as s, StyledFooter as c, StyledHeader as l, StyledNotification as u, StyledTag as d, StyledTags as f, TimestampWrapper as p, UnreadDot as m } from "./styled/Notification.styled.mjs";
import "react";
import { jsx as h, jsxs as g } from "react/jsx-runtime";
//#region src/components/Notification/Notification.tsx
var _ = ({ title: t, icon: s, timestamp: c, unread: u = !1, tone: d = "neutral", className: f }) => /* @__PURE__ */ g(l, {
	className: f,
	children: [/* @__PURE__ */ g(r, { children: [s && /* @__PURE__ */ h(o, {
		$tone: u ? d : "neutral",
		children: s
	}), /* @__PURE__ */ h(a, { children: t && /* @__PURE__ */ h(n, {
		color: u ? "primary" : "secondary",
		weight: u ? "semibold" : "medium",
		children: t
	}) })] }), /* @__PURE__ */ g(i, { children: [c && /* @__PURE__ */ h(p, { children: /* @__PURE__ */ h(e, {
		color: "secondary",
		weight: "medium",
		inline: !0,
		children: c
	}) }), u && /* @__PURE__ */ h(m, {})] })]
}), v = ({ children: e, className: n }) => /* @__PURE__ */ h(s, {
	className: n,
	children: /* @__PURE__ */ h(t, {
		color: "secondary",
		children: e
	})
}), y = ({ children: e, className: t }) => /* @__PURE__ */ h(f, {
	className: t,
	children: e
}), b = ({ children: t, icon: n, tone: r = "neutral", className: i }) => /* @__PURE__ */ g(d, {
	$tone: r,
	className: i,
	children: [n, /* @__PURE__ */ h(e, {
		color: "inherit",
		weight: "medium",
		inline: !0,
		children: t
	})]
}), x = ({ children: e, className: t }) => /* @__PURE__ */ h(c, {
	className: t,
	children: e
}), S = ({ children: e, unread: t = !1, className: n, ...r }) => /* @__PURE__ */ h(u, {
	$unread: t,
	className: n,
	...r,
	children: e
});
S.Header = _, S.Body = v, S.Tags = y, S.Tag = b, S.Footer = x;
//#endregion
export { S as Notification };
